import React from "react"
import styled from "styled-components"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faQuoteLeft, faQuoteRight } from "@fortawesome/free-solid-svg-icons"
import vCover from "assets/images/banner-cover.jpg"
import vSrc from "assets/videos/banner.mp4"
import mVocal from "assets/music/vocal.mp3"
import mWind from "assets/music/wind.mp3"

const Container = styled.div`
		height: 100vh;
		overflow: hidden;
		position: relative;
	`,
	VideoBg = styled.video`
		width: 100%;
		height: 100%;
		object-fit: cover;
		object-position: 34% center;
		position: absolute;
		top: 0;
		z-index: 1;
	`,
	GreetWrap = styled.div`
		height: 100%;
		padding: 0 15px;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		transform: translateY(180px);
		position: relative;
		z-index: 2;
	`,
	SayHi = styled.h1`
		margin-bottom: 20px;
		color: #fff;
		font-size: 64px;
		font-weight: bolder;
		text-shadow: 6px 6px 12px rgba(0, 0, 0, 0.7);
		@media (max-width: 468px) {
			font-size: 38px;
		}
	`,
	Intro = styled.p`
		padding: 20px;
		color: #ccc;
		font-size: 15px;
		background: rgba(0, 0, 0, 0.5);
		border-radius: 12px;
		position: relative;
		&::after {
			content: "";
			border-width: 15px;
			border-style: solid;
			border-color: transparent transparent rgba(0, 0, 0, 0.5) transparent;
			position: absolute;
			top: -30px;
			left: 20%;
		}
		@media (max-width: 468px) {
			padding: 12px;
		}
	`,
	QuoteIcon = styled(FontAwesomeIcon)`
		margin: 0 3px;
		font-size: 12px;
		transform: translateY(-3px);
	`

export default function Banner() {
	return (
		<Container>
			<GreetWrap>
				<SayHi>Hi,My Friends</SayHi>
				<Intro>
					<QuoteIcon icon={faQuoteLeft} />
					Although we are strangers, we are friends when you visit my blog
					<QuoteIcon icon={faQuoteRight} />
				</Intro>
			</GreetWrap>
			<VideoBg poster={vCover} loop muted autoPlay>
				<source src={vSrc} type="audio/mp4" /> 您的浏览器不支持播放此视频.
			</VideoBg>
			<audio loop autoPlay>
				<source src={mVocal} type="audio/mp3" />
			</audio>
			<audio loop autoPlay>
				<source src={mWind} type="audio/mp3" />
			</audio>
		</Container>
	)
}
